import styled from 'styled-components';
import CarWithBgIconSvg from './carwithbg.svg';

const CarWithBgIcon = styled(CarWithBgIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || '#647a97'};
  
`;

export default CarWithBgIcon;

